import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import ls from 'localstorage-slim';
import { SUPER_USER } from 'src/app/app.constants';
import { AnnouncementService } from 'src/app/services/messages/announcement/announcement.service';
import { MessagesService } from 'src/app/services/messages/messages.service';
import { NotificationService } from 'src/app/services/messages/notification/notification.service';
import { PollsService } from 'src/app/services/messages/polls/polls.service';
import { SupportChatService } from 'src/app/services/messages/support-chat/support-chat.service';
import { OrdersService } from 'src/app/services/orders/orders.service';
import { AppState } from 'src/app/store';
import { MessageType } from '../../../enums/message-type.enum';
import * as fromMessagesActions from '../../../store/actions/messages/messages.actions';

@Component({
  selector: 'lns-message-item',
  templateUrl: './message-item.component.html',
  styleUrls: ['./message-item.component.scss']
})
export class MessageItemComponent {
  @Input() messageData: any;

  constructor(
    private route: Router,
    private store: Store<AppState>,
    private messagesService: MessagesService,
    private notificationService: NotificationService,
    private pollsService: PollsService,
    private supportChat: SupportChatService,
    private ordersService: OrdersService,
    private announcementService: AnnouncementService
  ) {}

  routeLink(): void {
    this.selectMessageType();
    setTimeout(() => {
      if (this.messageData.messageType === MessageType.Support) {
        this.route.navigate([
          '/messages',
          { outlets: { sidebar: ['support-chat', this.messageData?.id] } }
        ]);
      } else if (this.messageData.messageType === MessageType.Announcement) {
        this.route.navigate([
          '/messages',
          {
            outlets: {
              sidebar: ['announcements-details', this.messageData?.id]
            }
          }
        ]);
      } else if (this.messageData.messageType === MessageType.Poll) {
        this.route.navigate([
          '/messages',
          { outlets: { sidebar: ['polls-details', this.messageData?.id] } }
        ]);
      } else if (this.messageData.messageType === MessageType.Notification) {
        this.route.navigate([
          '/messages',
          {
            outlets: { sidebar: ['notification-details', this.messageData?.id] }
          }
        ]);
      } else if (this.messageData.messageType === MessageType.Order) {
        this.route.navigate([
          '/messages',
          { outlets: { sidebar: ['order-details', this.messageData?.id] } }
        ]);
      }
    }, 400);
  }

  selectMessageType(): void {
    let superUser = ls.get(SUPER_USER);

    if (this.messageData?.messageType === 'NOTIFICATION') {
      this.getNotificationById(this.messageData?.id);
    }
    if (this.messageData?.messageType === 'ANNOUNCEMENT') {
      this.getAnnouncementById(this.messageData?.id);
    }
    if (this.messageData?.messageType === 'POLL') {
      this.getPollById(this.messageData?.id);
    }
    if (this.messageData?.messageType === 'SUPPORT') {
      this.getMessageById(this.messageData?.id);
    }
    if (this.messageData?.messageType === 'ORDER') {
      this.getOrderMessageById(this.messageData?.id);
    }
    if (superUser === false && this.messageData?.read === false) {
      this.getMessageAsRead(this.messageData?.id);
    }
  }

  getMessageAsRead(id: number): void {
    this.messagesService.markMessageAsRead(id).subscribe(() => {
      this.store.dispatch(
        fromMessagesActions.updateMessageDetails({
          read: true
        })
      );
    });
  }

  getNotificationById(id?: number): void {
    this.notificationService.retrieveNotification(id).subscribe(res => {
      this.dispatchMessageDetails(res.body);
    });
  }
  getOrderMessageById(id?: number): void {
    this.ordersService.getOrderMessageById(id).subscribe(res => {
      this.dispatchMessageDetails(res.body);
    });
  }
  getAnnouncementById(id?: number): void {
    this.announcementService.retrieveAnnouncements(id).subscribe(res => {
      this.dispatchMessageDetails(res.body);
    });
  }
  getPollById(id?: number): void {
    this.pollsService.retrievePolls(id).subscribe(res => {
      this.dispatchMessageDetails(res.body);
    });
  }
  getMessageById(id?: number): void {
    this.supportChat.retrieveSupportMessageById(id).subscribe(res => {
      this.dispatchMessageDetails(res.body);
    });
  }

  dispatchMessageDetails(details: any) {
    this.store.dispatch(
      fromMessagesActions.setMessageDetails({
        messageDetails: details
      })
    );
  }
}
